import React from "react";
import CatalogCollectionPage from "./CatalogCollectionPage";

export default function ConsulenzePage() {
  return (
    <CatalogCollectionPage
      collectionKey="consulenze"
      eyebrow="Servizi · Consulenze"
      title="Consulenze."
      description="Consulenze mirate del progetto TIME. Contenuti in preparazione."
      testId="consulenze"
    />
  );
}
